import { defineMessages } from 'react-intl';

type MessageKeys =
	| 'aggErrorHeading'
	| 'aggErrorMessage'
	| 'aggErrorMessageSubtext'
	| 'aggErrorAction';

const message: Record<MessageKeys, { defaultMessage: string; description?: string; id: string }> =
	defineMessages({
		aggErrorHeading: {
			id: 'studio.foundation.agg-error.heading',
			defaultMessage: 'Studio Core Service Network Error',
			description: 'Heading for AGG Network Error page',
		},
		aggErrorMessage: {
			id: 'studio.foundation.agg-error.message',
			defaultMessage:
				'An error occurred while trying to access core Studio service data. This error is fatal. (err code: AGG)',
			description: 'Message for AGG Network Error page',
		},
		aggErrorMessageSubtext: {
			id: 'studio.foundation.agg-error.message-subtext',
			defaultMessage:
				'Sometimes this error is caused by an invalid browser user session. You could try signing in again.',
			description: 'Subtext for AGG Network Error page',
		},
		aggErrorAction: {
			id: 'studio.foundation.agg-error.action',
			defaultMessage: 'Sign in',
			description: 'Action for AGG Network Error page',
		},
	});

export default message;
